module.exports = __webpack_public_path__ + "img/hungary.1eaf5df0.jpg";